import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  Input,
  ViewChild,
  ViewContainerRef
} from "@angular/core";
import {multiLinkMixin} from "../../mixins/multi-link.mixin";
import {Dialect, SimpleDialect} from "../../models/dialect.model";
import {Router} from "@angular/router";
import {DynamicComponentService} from "../../services/dynamic-component/dynamic-component.service";
import {GlobalEventService} from "../../services/global-event/global-event.service";
import {LayoutMgrService} from "../../services/layout-mgr/layout-mgr.service";


@Component({
  selector: 'app-dialect-detail-standard',
  template: `
    <div class="subject-box vcenter" #headerStandard
         style="top:17px;"
         *ngIf="dialect.standard || dialect.standardWord">표준말
    </div>
    <div class="con-box standard"
         *ngIf="dialect.standard">

      <div class="row-item-box">
        <div class="keyword-box" #bodyStandard
             (click)="onStandard($event, dialect.standard.id)">
          <app-dialect-disp [word]="dialect.standard"></app-dialect-disp>
        </div>
      </div>

    </div>

    <!-- 표준어 연결은 없지만, 표준어 텍스트는 있는 경우 -->
    <div class="con-box standard"
         *ngIf="!dialect.standard && dialect.standardWord">
      <div class="keyword-box" #bodyStandard>
        <div class="standard-txt"
             [innerHTML]="dialect.standardWord | resize"></div>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialectDetailStandardComponent extends multiLinkMixin {
  // @HostBinding('style.display') display = 'block';
  @ViewChild('headerStandard') header: ElementRef;
  @ViewChild('bodyStandard') body: ElementRef;
  @Input() dialect?: Dialect;


  public get width(): number {
    return this.header?.nativeElement.clientWidth + this.body?.nativeElement.clientWidth;
  }

  constructor(
    public router: Router,
    public dynamicSvc: DynamicComponentService,
    public lm: LayoutMgrService,
    private eRef: ElementRef,
    private globalEventSvc: GlobalEventService,
  ) {
    super(router, dynamicSvc, lm);
  }

  /**
   * 사투리 상세 화면에서 표준어를 누르면 단어 검색 이력으로 이동하게 하는 함수.
   * @param $event 마우스 이벤트
   * @param idWord 이동할 단어 번호
   */
  public onStandard($event: MouseEvent, idWord: string): void {
    $event.preventDefault();
    $event.stopPropagation();
    this.globalEventSvc.Click($event, true);

    if (idWord) {
      this.OpenMultiLink(idWord).subscribe(resultLinkPopup => {
        console.warn('DialectDetailStandardComponent.onClick() resultLinkPopup =', resultLinkPopup);
      });
    }
  }
}
